export const SHOW_NAVIGATION = 'SHOW_NAVIGATION';
export const HIDE_NAVIGATION = 'HIDE_NAVIGATION';
export const NAVIGATE_NEXT = 'NAVIGATE_NEXT';
export const NAVIGATE_PREVIOUS = 'NAVIGATE_PREVIOUS';
export const NAVIGATE_TO = 'NAVIGATE_TO';
export const NAVIGATE_TO_SCREEN = 'NAVIGATE_TO_SCREEN';
export const NAVIGATE_BY_HISTORY = 'NAVIGATE_BY_HISTORY';

export const SET_AGE_GROUP = 'SET_AGE_GROUP';
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const SET_ROOM = 'SET_ROOM';

export const SET_LEVEL = 'SET_LEVEL';

export const navigateNext = () => ({
    type: NAVIGATE_NEXT,
});

export const navigatePrevious = () => ({
    type: NAVIGATE_PREVIOUS,
});

export const navigateTo = (page) => ({
    type: NAVIGATE_TO,
    payload: {
        page,
    }
});

export const navigateToScreen = (screen) => ({
    type: NAVIGATE_TO_SCREEN,
    payload: {
        screen,
    }
})

export const setRoom = (id, name) => ({
    type: SET_ROOM,
    payload: {
        id,
        name,
    }
});

export const showNavigation = () => ({
    type: SHOW_NAVIGATION,
});

export const hideNavigation = () => ({
    type: HIDE_NAVIGATION,
})

export const setAgeGroup = (ageGroup) => ({
    type: SET_AGE_GROUP,
    payload: {
        ageGroup,
    },
});

export const setParticipants = (participants) => ({
    type: SET_PARTICIPANTS,
    payload: {
        participants,
    },
});

export const setLevel = (level) => ({
    type: SET_LEVEL,
    payload: {
        level,
    },
});

export const navigateByHistory = (page) => ({
    type: NAVIGATE_BY_HISTORY,
    payload: {
        page,
    }
});
